import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { usePageHeading } from './hooks/usePageHeading';

export function PageHeading(): JSX.Element {
	const {
		data: { pageTitle, updatedAt },
	} = usePageHeading();

	return (
		<div className="mb-10">
			<Text variant="heading" size="x-large" as="h1" className="mb-6">
				{pageTitle}
			</Text>
			{updatedAt && (
				<Text className="text-typography-weak" size="large">
					<Translate value="fe.pages.policies.last_updated" replacements={{ date: updatedAt }} />
				</Text>
			)}
		</div>
	);
}
